<template>
<div class="track-overview">
  <el-row class="container-card el-row">
    <TrackOverview />
  </el-row>
</div>
</template>

<script>
import TrackOverview from '@/modules/artist/tracks/components/OverviewTable'
import {mapGetters, mapMutations, mapState} from "vuex";

export default {
  components: {
    TrackOverview
  },

  computed: {
    ...mapGetters('auth', ['artist_role']),
    ...mapState('auth', ['user'])
  },

  methods: {
    ...mapMutations('artistDashboard', ['setSelectedArtist'])
  },

  mounted() {
    if (this.artist_role) this.setSelectedArtist(null)
  }
}
</script>

<style scoped>

</style>
